export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const CREATE_USER_ALREADY_EXIST = 'CREATE_USER_ALREADY_EXIST';

export const FETCH_ALL_ORGANIZATION_SUCCESS = 'FETCH_ALL_ORGANIZATION_SUCCESS';
export const FETCH_ALL_ORGANIZATION_FAILURE = 'FETCH_ALL_ORGANIZATION_FAILURE';